import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        width: 21,
        height: 21,
        backgroundColor: Theme.secondaryButtonBackgroundColor,
        borderWidth: 1,
        borderColor: Theme.secondaryButtonBorderColor,
        borderRadius: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    icon: {
        width: '85%',
        height: '85%'
    }
};

export default StyleSheet.create(baseStyles);
